import React, { useState } from "react";
import PropTypes from "prop-types";
import FieldBuilder from "../../fields/fields-builder";

const AlertsContainer = ({ dialogs, appData, components, screen }) => {
  const [currentItem, setCurrentItem] = useState(0);

  const setNextItem = () => setCurrentItem(currentItem + 1);

  const getAriaLabel = dialog => {
    if (!dialog?.accessibility?.label) {
      return appData.settings.translations.cancel_banner;
    }
    return dialog.accessibility.label;
  };

  const renderCurrentItem = dialog => (
    <div className={`alertNotification ${dialog.name}`}>
      {dialog.fields.map(field => (
        <FieldBuilder
          key={`field_${field.name}`}
          field={field}
          appData={appData}
          components={components}
          screen={screen}
        />
      ))}
      <button
        type='button'
        onClick={setNextItem}
        className='closeAlertButton'
        aria-label={getAriaLabel(dialog)}
      />
    </div>
  );

  return dialogs[currentItem] ? renderCurrentItem(dialogs[currentItem]) : null;
};

AlertsContainer.propTypes = {
  dialogs: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  ).isRequired,
  components: PropTypes.objectOf(PropTypes.func).isRequired,
  appData: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.func,
      PropTypes.object,
      PropTypes.array,
      PropTypes.string
    ])
  ).isRequired,
  screen: PropTypes.object.isRequired
};

export default AlertsContainer;
